import { MessageProps } from 'components/Dialogue';
import dayjs, { Dayjs } from 'lib/dayjs';
import { UIMessages } from './useChatView';

/**
 * 接口未开放发送引用消息，乐聊端引用文本消息通过字符串特殊处理,
 */
export function injectQuote(raw: Conversation.Message) {
  const { quotedMsgId, quotedTextContent } = raw;
  if (quotedMsgId && quotedTextContent?.text) {
    /* eslint-disable */
    raw.quotedMsg = {
      msgId: quotedMsgId,
      messageType: 'TEXT',
      textContent: {
        text: quotedTextContent.text,
        originalText: quotedTextContent.text,
      },
    } as Conversation.QuotedMessage;
  }
}

export const getMetaFromSender = (sender: UIMessages['sender']) => {
  const isBuyerMessage = sender === 'buyer';
  const isRobotMessage = sender === 'robot';
  const isSellerMessage = sender === 'seller';
  const layout: MessageProps['layout'] = isBuyerMessage ? 'left' : 'right';
  const color = layout === 'right' ? '#D6E8FF' : '#fff';

  return {
    isBuyerMessage,
    isRobotMessage,
    isSellerMessage,
    layout,
    color,
  };
};

export const timeFormatter = (time: number | Dayjs) => {
  const day = dayjs(time);
  const isSameYear = day.isSame(dayjs(), 'years');
  return day.format(isSameYear ? 'MM-DD HH:mm' : 'YYYY-MM-DD HH:mm');
};

export const isValidConversationId = (conversationId?: string) => {
  return conversationId && conversationId !== '0';
};
